"use strict";

export default () => {
    /**
     * A 'class' to store and persist user and account information.
     * As of 20/12/2018, this class is not being used but should eventually replace calls to
     * window.localStorage in main.js and address.js, etc.
     *
     * @class
     * @name User
     */
    function User() {
        //Stores the data relating to the user. Is serialised into localstorage for persistence - see User.get && User.prototype.save
        this.data = {};
    }

    /**
     * A static property for storing the current User.
     *
     * @property
     * @static
     * @name user
     * @memberOf User
     */
    User.user = null;

    /**
     * Gets the current user from storage and builds a User object.
     *
     * @name get
     * @static
     * @memberOf User
     * @param {Boolean} refresh Forces the recreation of the static user if TRUE.
     */
    User.get = function (refresh) {
        if ((User.user === null) || ((typeof refresh == 'boolean') && refresh)) {
            var json = window.localStorage.getItem('user');
            var user = new User();
            if (json) {
                user.setData(JSON.parse(json));
            }
            User.user = user;
        }
        return User.user;
    };

    /**
     * Saves the data property of the User object to local storage by
     */
    User.prototype.save = function () {
        window.localStorage.setItem('user', JSON.stringify(this.data));
        return this;
    };

    /**
     * Setter for data property.
     */
    User.prototype.setData = function (data) {
        this.data = data;
        return this;
    };

    /**
     * Updates a property of the User data.
     */
    User.prototype.updateData = function (key, value, save) {
        this.data[key] = value;
        if ((typeof save == 'boolean') && save) {
            this.save();
        }
        return this;
    };
}
